<template>
	<div class="forgot-wrapper">
		<loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" :height="150" :width="150"
			:color="'#FFFF00'" :background-color="'#000000'" :opacity="0.5"></loading>

		<v-container fill-height fluid class="d-flex align-center justify-center" v-if="!isLoading">
			<v-row align="center" justify="center">
				<v-col cols="4" md="4" xs="12" sm="12"></v-col>
				<v-col cols="4" md="4" xs="12" sm="12" class="mt-8">
					<v-card elevation="3" style="border-radius:16px;border:1px solid #E8EDF5;padding:28px 32px 8px 32px;">
					<div v-if="!isSubmitted">
						<h2 class="mb-3" style="letter-spacing:normal;">
							{{ $t('forgotpassword.verifyby') }}
						</h2>

						<v-radio-group v-model="selectedOption" row class="mt-1 mb-2">
							<v-radio v-for="opt in verifyOptions" :key="opt.value" :value="opt.value" :label="opt.label"></v-radio>
						</v-radio-group>

						<div v-if="selectedOption === 'username'">
							<v-text-field outlined dense class="mb-2" :label="$t('reccontactdetails.username')"
								:rules="[rules.required]" v-model="formData.username"></v-text-field>
							<v-text-field outlined dense class="mb-2" :label="$t('reccontactdetails.email')"
								type="email" :rules="[rules.required, rules.email]"
								v-model="formData.email"></v-text-field>
						</div>

						<div v-if="selectedOption === 'idnumber'">
							<v-autocomplete outlined dense class="mb-2" v-model="formData.idtype" :items="idTypeList"
								item-text="text" item-value="value" :label="$t('reccontactdetails.idtype')"
								:rules="[rules.required]"></v-autocomplete>
							<v-text-field outlined dense class="mb-2" :label="$t('reccontactdetails.idnumber')"
								:rules="[rules.required]" v-model="formData.idnumber"></v-text-field>
							<v-text-field outlined dense class="mb-2" :label="$t('reccontactdetails.email')"
								type="email" :rules="[rules.required, rules.email]"
								v-model="formData.email"></v-text-field>
						</div>

						<p class="mt-1 text-left" style="font-size:0.82rem;color:#546e7a;">
							{{ $t('forgotpassword.emailregistered') }}<br />
							{{ $t('forgotpassword.assistance') }}
						</p>
					</div>

					<div v-if="isSubmitted" class="text-center mt-6">
						<p class="text-body-2">
							{{ $t('forgotpassword.emailsentto') }}
							<span class="font-weight-bold">{{ formData.email }}</span>.
							<br />
							{{ $t('forgotpassword.checkemail') }}
						</p>
					</div>

					<div class="form-btn-bar mt-4">
						<div class="form-btn-inner">
							<v-btn v-if="!isSubmitted" class="fbtn fbtn-success" @click="buttonHandler">
								<v-icon size="16" class="mr-1">mdi-send</v-icon>
								{{ $t('button.send') }}
							</v-btn>
							<v-btn class="fbtn fbtn-cancel" @click="BackButtonHandler">
								<v-icon size="16" class="mr-1">mdi-arrow-left</v-icon>
								{{ $t('button.back') }}
							</v-btn>
						</div>
					</div>
				</v-card>
				</v-col>
				<v-col cols="4" md="4" xs="12" sm="12"></v-col>
			</v-row>
		</v-container>

		<div v-if="isErr">
			<app-error :parentError="{ data: errMsg, isErr: isErr }" @closeError="isErr = $event" />
		</div>
	</div>
</template>

<script>
import ErrorDialog from "./ErrorDialog";
import Loading from "vue-loading-overlay";
// import moment from "moment";
//import GenericForm from '../../../generic/GridForm';

export default {
	props: {
		parentObject: Object,
	},

	components: {
		//'app-genericform': GenericForm,
		"app-error": ErrorDialog,
		Loading,
	},

	data() {
		return {
			rules: {
				required: (value) => !!value || this.$t('reportsparam.required'),
				email: (value) => {
					const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					return pattern.test(value) || "Invalid e-mail.";
				},
			},

			/* NEW */
			selectedOption: "username",
			verifyOptions: [
				{ label: "Username + Email", value: "username" },
				{ label: "ID number + Email", value: "idnumber" }
			],
			idTypeList: [],

			formData: {
				email: "",
				username: "",
				idtype: null,
				idnumber: "",
			},

			isLoading: true,
			isErr: false,
			errMsg: "",
			isSubmitted: false,
			db: this.$route.params.db,
		};
	},


	methods: {
		BackButtonHandler() {
			const vm = this;
			// this.$router.replace({ name: "login" });
			// this.$router.replace("/" + this.$i18n.locale + "/home/" + vm.db);
			window.location.href = "/" + this.$i18n.locale + "/home/" + vm.db;

		},

		buttonHandler() {
			const vm = this;
			let payload = {};

			//front end validation
			if (vm.formData.email === "") {
				vm.isErr = true;
				vm.errMsg = "Email is required.";
				return;
			}
			if (vm.selectedOption === "username") {
				if (vm.formData.username === "") {
					vm.isErr = true;
					vm.errMsg = "Username is required.";
					return;
				}
			}
			else {
				if (vm.formData.idnumber === "") {
					vm.isErr = true;
					vm.errMsg = "ID Number is required.";
					return;
				}
				if (vm.formData.idtype === "" || vm.formData.idtype === null ||
					vm.formData.idtype === undefined || vm.formData.idtype === 0) {
					vm.isErr = true;
					vm.errMsg = "ID Type is required.";
					return;
				}
			}
			//end front end validation
			//Start assemble payload
			payload.email = vm.formData.email;
			if (vm.selectedOption === "username") {
				payload.action = 1;// by username
				payload.username = vm.formData.username;
			} else if (vm.selectedOption === "idnumber") {
				payload.action = 2; // by idnumber
				payload.idtype = vm.formData.idtype;
				payload.idnumber = vm.formData.idnumber;
			}
			else {
				payload.action = 9999; // invalid action
			}

			this.$store.dispatch('post', {
				url: "/forgotpassword",
				payload: payload,
				headers: { db: vm.db }
			})
				.then((res) => {
					if (res.data.status != 201) {
						vm.isErr = true;
						vm.errMsg = res.data.error;
						this.isSubmitted = false;
					} else {
						this.isSubmitted = true;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},

		async loadIdTypes() {
			const vm = this;
			this.$store.dispatch('post', { url: '/psnidnotype/all/forgotpswpage', headers: { db: vm.db } })
				.then(res => {
					for (let i = 0; i < res.data.rec.length; i++) {
						vm.idTypeList.push(
							{
								text: res.data.rec[i].idtypecode,
								value: res.data.rec[i].id
							}
						)
					}
					if ((vm.formData.idtype === "" || vm.formData.idtype === null) && vm.idTypeList.length > 0) {
						vm.formData.idtype = vm.idTypeList[0].value;
					}
				})
				.catch(err => {
					vm.isErr = true;
					vm.errMsg = "Person ID Number Type Error: " + err;
					vm.$emit('error', { isErr: vm.isErr, errMsg: vm.errMsg });
				});
		},

	},

	async mounted() {
		try {
			this.isLoading = true;
			await this.loadIdTypes();
		}
		catch (err) {
			this.isErr = true;
			this.errMsg = "Forgot Password Page Mounted Error: " + err;
			this.$emit('error', { isErr: this.isErr, errMsg: this.errMsg });
		}
		finally {
			this.isLoading = false;
		}
	}
}
</script>

<style>
.v-content {
	height: 100%;
}
.form-btn-bar {
  background: #F8FAFF;
  border-top: 1px solid #E8EDF5;
  padding: 12px 16px;
  border-radius: 0 0 16px 16px;
  margin-top: 8px;
}
.form-btn-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}
.fbtn {
  min-width: 100px !important;
  height: 38px !important;
  border-radius: 8px !important;
  font-size: 0.82rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.02em !important;
  box-shadow: none !important;
}
.fbtn-success { background: #059669 !important; color: #fff !important; }
.fbtn-success:hover { background: #047857 !important; }
.fbtn-cancel { background: #F1F5F9 !important; color: #64748B !important; }
.fbtn-cancel:hover { background: #E2E8F0 !important; color: #334155 !important; }
</style>